import { logError } from '@/sdkConsole';

// Publisher hooks are untrusted; a throwing callback must never break the
// checkout flow (mirrors the cmd-queue ready-callback handling in sdk.ts).
export function runHook<A extends unknown[]>(hook: ((...args: A) => void) | undefined, label: string, ...args: A): void {
  if (!hook) return;
  try {
    hook(...args);
  } catch (err) {
    logError(`${label} callback failed`, err);
  }
}
